import { render, staticRenderFns } from "./MetricTable.vue?vue&type=template&id=76cb42a5&scoped=true"
import script from "./MetricTable.vue?vue&type=script&lang=js"
export * from "./MetricTable.vue?vue&type=script&lang=js"
import style0 from "./MetricTable.vue?vue&type=style&index=0&id=76cb42a5&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cb42a5",
  null
  
)

export default component.exports